import { TableCell, TableRow } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

interface SkeletonRowProps {
  columnsCount?: number;
}

const SkeletonRow = ({ columnsCount = 5 }: SkeletonRowProps) => (
  <TableRow>
    {Array.from(new Array(columnsCount)).map((_data, idx) => (
      <TableCell key={idx}>
        <Skeleton />
      </TableCell>
    ))}
  </TableRow>
);

export default SkeletonRow;
